import useStore from "../store";
import moment from "moment";

const getStore = () => useStore();

export const findAttraction = (id) => {
    const store = getStore();

    if (store.attractions){
        return store.attractions.find(a => a.id === id)
    }

    return false;
}

export const isWalkInOnly = (id, checkDate = null) => {
    const attraction = findAttraction(id);
    const ranges = attraction?.walkin_only_dates ?? [];

    if (!ranges.length) return false;

    const dateToCheck = checkDate ? moment(checkDate) : moment();

    return ranges.some(range =>
        dateToCheck.isBetween(moment(range.start), moment(range.end), 'day', '[]')
    );
}

export const oneDate = (id) => {
    return findAttraction(id)?.one_date;
}

export const oneDateOnly = (id) => {
    return oneDate(id)?.active ?? false
}

export const attractionProductCodes = (attraction) => [
    attraction?.rezdy_retail_product_code,
    ...(Array.isArray(attraction?.rezdy_product_options)
        ? attraction.rezdy_product_options.map((option) => option?.product)
        : []),
].filter(Boolean)

export const attractionFromProductCode = (attractions = [], productCode = '') => (
    attractions.find((attraction) => attractionProductCodes(attraction).includes(productCode)) ?? null
)
